import './style.styl';

export default __filename;
angular.module(__filename, []).factory(
  'submitPOConfirmationModal',
  ngInject(($uibModal) => ({
    open({form, vendorEmail}) {
      const modalInstance = $uibModal.open({
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
        size: 'lg',
        resolve: {
          form: () => form,
          vendorEmail: () => vendorEmail,
        },
      });
      return modalInstance.result;
    },
  })),
);
